import { createContext, useContext, useState, useCallback } from "react";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("suym_lang") || "en");

  const toggle = useCallback(() => {
    setLang((l) => {
      const next = l === "en" ? "fr" : "en";
      localStorage.setItem("suym_lang", next);
      return next;
    });
  }, []);

  const t = useCallback((en, fr) => (lang === "fr" ? (fr ?? en) : en), [lang]);

  return <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);

/** Overlay every `${field}_fr` key onto its base field, recursively, when in FR. */
export function localizeDeep(value) {
  if (Array.isArray(value)) return value.map(localizeDeep);
  if (value && typeof value === "object") {
    const out = {};
    for (const [k, v] of Object.entries(value)) out[k] = localizeDeep(v);
    for (const k of Object.keys(value)) {
      if (k.endsWith("_fr") && value[k]) out[k.slice(0, -3)] = value[k];
    }
    return out;
  }
  return value;
}
